<div class="login-container">
  <div class="flex flex-col items-center gap-8">
    <button (click)="loginButtonClick()" class="login-button">
      <img
        alt="audaces-logo"
        class="w-6 h-6"
        src="./assets/images/Audaces_Vector.png"
      />
      {{ "login.button" | translate }}
    </button>
  </div>
</div>
